import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTopic = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 242,
	height: 224,
	viewBox: "0 0 242 224",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 1.104,
			y: 1,
			width: 239.792,
			height: 222,
			rx: 6,
			fill: "#F5F7FB",
			stroke: "#F1F2FA",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14 20H204Z",
			fill: "#F5F7FB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14 20H204",
			stroke: "#6324C6",
			strokeWidth: 8,
			strokeMiterlimit: 10,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .8,
			d: "M13.8965 37H222.5",
			stroke: "#E2E5E9",
			strokeWidth: 6,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 152,
			y1: 143,
			x2: 167.088,
			y2: 143,
			stroke: "#774DC5",
			strokeWidth: 8,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 151,
			y1: 162,
			x2: 204.859,
			y2: 162,
			stroke: "#6324C6",
			strokeOpacity: .13,
			strokeWidth: 6,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 152,
			y1: 80,
			x2: 167.088,
			y2: 80,
			stroke: "#774DC5",
			strokeWidth: 8,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 151,
			y1: 99,
			x2: 204.859,
			y2: 99,
			stroke: "#6324C6",
			strokeOpacity: .13,
			strokeWidth: 6,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 18,
			y1: 152,
			x2: 33.0885,
			y2: 152,
			stroke: "#774DC5",
			strokeWidth: 8,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 17,
			y1: 163,
			x2: 96,
			y2: 163,
			stroke: "#6324C6",
			strokeOpacity: .13,
			strokeWidth: 6,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17 112L18.7485 108.796C21.7587 103.28 27.5412 99.8478 33.8254 99.8478H34.9277C38.6235 99.8478 42.1781 101.267 44.8573 103.813V103.813C49.8609 108.567 57.5322 109.108 63.153 105.102L68.1259 101.558C69.719 100.423 71.1521 99.0789 72.3869 97.5617L88.4556 77.8174C92.996 72.2384 99.8069 69 107 69V69",
			stroke: "#9B6CE4",
			strokeWidth: 4
		})
	]
});
export { SvgTopic as ReactComponent };
export { default } from "/home/runner/work/frontend_insights/frontend_insights/apps/insights/src/assets/images/svg/dashboardComponents/topic.svg?url";
